import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotMarker } from 'types';

export const clearTrendlineMarkers = ({
  snapshotId,
}: {
  snapshotId: number;
}) => {
  return axios.delete(`/api/snapshots/${snapshotId}/trendline-markers/clear`);
};

type UseClearTrendlineMarkersOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof clearTrendlineMarkers>;
};

export const useClearTrendlineMarkers = ({
  config,
  snapshotId,
}: UseClearTrendlineMarkersOptions) => {
  return useMutation({
    onMutate: async () => {
      await queryClient.cancelQueries(['snapshot', snapshotId, 'markers']);

      const previousMarkers = queryClient.getQueryData<SnapshotMarker[]>([
        'snapshot',
        snapshotId,
        'markers',
      ]);

      queryClient.setQueryData(['snapshot', snapshotId, 'markers'], []);

      return { previousMarkers };
    },
    onError: (_, __, context: any) => {
      if (context?.previousMarkers) {
        queryClient.setQueryData(
          ['snapshot', snapshotId, 'markers'],
          context.previousMarkers
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: clearTrendlineMarkers,
  });
};
